import { get, has } from 'lodash-es';
import { logger } from 'client/utils/logger/logger';
import { ModelPreloader } from 'client/data/luckdragon/redux/model-preloader';
import { InventoryModel } from 'client/data/models/inventory';
import { VehicleModel, buildVehiclePath } from 'client/data/models/vehicle';
import { TestCapitalOneModel } from 'client/data/models/test-capital-one';
import { updateVehicle, getVehicleFromInventoryVin } from 'client/actions/vehicle';
import { toSlug } from 'site-modules/shared/utils/car-buying/vehicle-util';
import { recordError } from 'site-modules/shared/utils/car-buying/client-error-handler';
import { get410Error } from 'site-modules/shared/utils/inventory/vdp-utils';
import { CALCULATORS_PATHS, CalculatorsModel } from 'client/data/models/calculators';
import { FinancingModel, PATHS } from 'client/data/models/financing';
import { ClientConfig } from 'client/configuration';
import { getQuery } from 'client/utils/location';
import { CHOOSE_ELIGIBLE_VIN, ERROR_STEP, LOOK_UP_STEP } from 'site-modules/shared/constants/financing/steps';
import { legacyPageUpdate } from 'client/actions/legacy-page';
import { PRE_VIN_PATH } from 'site-modules/financing/constants/financing';
import { PUB_STATES } from 'client/constants/pub-states';

export async function FinancingDecoratorFactoryPreload(store, props) {
  const preloader = new ModelPreloader(store);

  const query = getQuery(props.location);
  const isProdEnv = !ClientConfig.get('financing');
  const chooseEligibleVin = has(query, CHOOSE_ELIGIBLE_VIN);
  const isLookUp = has(query, LOOK_UP_STEP);
  const isPreVinFlow = props.location.pathname.includes(PRE_VIN_PATH);

  if (!isProdEnv && chooseEligibleVin) {
    preloader.resolve('vehiclesWithProviderCapitalOne', TestCapitalOneModel);
    return preloader.load();
  }

  const { step } = props.match.params;
  if (step === ERROR_STEP) {
    // save page name
    store.dispatch(
      legacyPageUpdate({
        pageName: `financing_message_${isLookUp ? 'lookup_existing' : 'new_app'}`,
        categoryName: 'financing',
      })
    );
  }

  preloader.resolve(PATHS.PREQUALIFICATION_DATA, FinancingModel);

  if (!isPreVinFlow) {
    const { vin } = props.match.params;
    const vinPath = `vin["${vin}"]`;

    preloader.resolve(vinPath, InventoryModel);
    preloader.resolve(CALCULATORS_PATHS.CALCULATOR_LOAN_SELECTIONS, CalculatorsModel);

    return preloader
      .load()
      .then(modelState => {
        const vinData = modelState.get(vinPath, InventoryModel);
        const calculatorSelections = modelState.get(CALCULATORS_PATHS.CALCULATOR_LOAN_SELECTIONS, CalculatorsModel);
        const { make, model, year } = get(vinData, 'vehicleInfo.styleInfo');
        const vehiclePath = buildVehiclePath({ make: toSlug(make), model: toSlug(model), year });
        preloader.resolve(vehiclePath, VehicleModel);
        preloader.set(PATHS.CALCULATOR_SELECTIONS({ vin }), FinancingModel, calculatorSelections);

        const vehicleData = modelState.get(vehiclePath, VehicleModel);

        store.dispatch(updateVehicle(getVehicleFromInventoryVin(vinData, vehicleData)));

        return preloader.load();
      })
      .catch(e => {
        recordError();
        logger.error(e);
        throw get410Error(vinPath);
      });
  }

  // added for tracking
  store.dispatch(updateVehicle({ publicationState: PUB_STATES.USED.toLowerCase() }));

  return preloader.load().catch(e => {
    recordError();
    logger.error(e);
  });
}
